import { Navigate, Route, Routes } from 'react-router-dom';

import { MenuInfo } from 'data';
import { MonitoringSettingLayout } from 'layout/monitoring';
import MonitoringSettingTabsRoutes from './MonitoringSettingTabsRoutes';
import usePermission from 'hooks/usePermission';
import RouteAccessError from 'pages/RouteAccessError';

export default function MonitoringSettingRoutes() {
    const setting = MenuInfo.CMMS_MANAGEMENT;

    const { hasPermission, isPermissionReady } = usePermission();
    if (!isPermissionReady) {
        return null;
    }
    const visibleMenus = setting.children.filter(menu => {
        const permissionOk =
            !menu.permission || hasPermission(menu.permission);

        const featureOk =
            menu.feature === undefined || menu.feature;

        return permissionOk && featureOk;
    });
    // console.log(visibleMenus)

    return (
        <Routes>
            <Route path="/*" element={ <MonitoringSettingLayout/> }>
                <Route path="/*" element={ <Navigate to={visibleMenus[0]?.path}/> }/>
                {
                    visibleMenus.map(child => {
                        return (
                    <Route key={'setting'+child.id} path={child.path + '/*'} element={ 
                        <MonitoringSettingTabsRoutes menuId={child.id}/>
                    }/>
                        )
                    }) 
                }
                <Route path="*" element={ <RouteAccessError /> }/>
            </Route>
        </Routes>
    );
}